import canvasRetina from 'marketing-website/media/images/pages/features/design/canvas@2x.jpg';
import fontsRetina from 'marketing-website/media/images/pages/features/design/card@2x.png';
import inputRetina from 'marketing-website/media/images/pages/features/design/input@2x.png';
import groupingRetina from 'marketing-website/media/images/pages/features/design/grouping@2x.png';
import rightClickRetina from 'marketing-website/media/images/pages/features/design/rightClick@2x.png';
import pickerRetina from 'marketing-website/media/images/pages/features/design/picker@2x.png';
import typographyFallbackRetina from 'marketing-website/media/images/pages/features/design/typographyFallback@2x.png';
import extraFallbackRetina from 'marketing-website/media/images/pages/features/design/extraFallback@2x.png';

const assets = {
  canvas: {
    alt: 'Design interfaces',
    src: canvasRetina,
  },
  fonts: {
    alt: 'Design interfaces',
    src: fontsRetina,
  },
  input: {
    alt: 'Design interfaces',
    src: inputRetina,
  },
  grouping: {
    alt: 'Design interfaces',
    src: groupingRetina,
  },
  rightClick: {
    alt: 'Design interfaces',
    src: rightClickRetina,
  },
  picker: {
    alt: 'Design interfaces',
    src: pickerRetina,
  },
  typographyFallback: {
    alt: '',
    maxWidth: 487,
    src: typographyFallbackRetina,
  },
  extraFallback: {
    alt: '',
    maxWidth: 609,
    src: extraFallbackRetina,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/features/design/assets.js